module.exports = __webpack_public_path__ + "b57866adf9cb1c337c991e401a38bda2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/flag.png
// module id = 3031
// module chunks = 0